import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { OscReferenceAppCommonModule } from 'osc-reference-app-common';
import { LayoutModule } from '@angular/cdk/layout';
import { OscUtilsModule } from '@osc-utils/osc-utils.module';
import { components } from './components';
import { materialModules } from './material';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    ...materialModules,
    OscReferenceAppCommonModule,
    OscUtilsModule,
    SharedModule,
    ReactiveFormsModule,
    ...components,
  ],
  exports: [...components],
})
export class FileListModule {}
